import React, { useState, useEffect } from 'react';
import './createCustomUrl.css'
import { getAuthHeader } from '../utils/tokenManager';

const apiUrl = process.env.REACT_APP_DJANGO_API_URL;

const CreateCustomUrl = ({ onCustomUrlSelect, selectedCustomUrl, accountId, inline = false, onSave, languageSetting }) => {
  const [temporaryUsername, setTemporaryUsername] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    const CustomUrlCopy = JSON.parse(JSON.stringify(selectedCustomUrl));
    if(CustomUrlCopy.value !== '') {
      setTemporaryUsername(CustomUrlCopy.value);
    }
  }, [selectedCustomUrl]);

  const handleYesClick = () => {
    setIsEditing(true);
    const CustomUrlCopy = JSON.parse(JSON.stringify(selectedCustomUrl));
    CustomUrlCopy.showInput = true;
    onCustomUrlSelect(CustomUrlCopy);
  };

  const handleNoClick = () => {
    setIsEditing(false);
    const CustomUrlCopy = JSON.parse(JSON.stringify(selectedCustomUrl));
    CustomUrlCopy.showInput = false;
    onCustomUrlSelect(CustomUrlCopy);
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    setTemporaryUsername(value);
  };

  const handleBlur = async () => {
    if (!temporaryUsername) return;

    // Only allow alphanumeric characters
    const isValid = /^[a-zA-Z0-9]*$/.test(temporaryUsername);
    
    if (!isValid) {
      const CustomUrlCopy = JSON.parse(JSON.stringify(selectedCustomUrl));
      CustomUrlCopy.error = true;
      CustomUrlCopy.errorMessage = 'Not a valid custom ID, only use letters and numbers.';
      CustomUrlCopy.value = '';
      onCustomUrlSelect(CustomUrlCopy);
      return;
    }

    try {
      const checkUrl = `${apiUrl}/api/check_if_custom_account_id_exists/?custom_id=${encodeURIComponent(temporaryUsername)}&account_id=${accountId}`;
      
      const response = await fetch(checkUrl, {
        headers: {
          'Content-Type': 'application/json',
          ...getAuthHeader()
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        const CustomUrlCopy = JSON.parse(JSON.stringify(selectedCustomUrl));
        
        if (data.status === "taken") {
          CustomUrlCopy.error = true;
          CustomUrlCopy.errorMessage = 'Username already exists.';
          CustomUrlCopy.value = '';
          onCustomUrlSelect(CustomUrlCopy);
        } else {
          CustomUrlCopy.error = false;
          CustomUrlCopy.value = temporaryUsername;
          CustomUrlCopy.errorMessage = '';
          onCustomUrlSelect(CustomUrlCopy);
          if (inline) {
            setIsEditing(false);
          }
        }
      } else {
        const CustomUrlCopy = JSON.parse(JSON.stringify(selectedCustomUrl));
        CustomUrlCopy.error = true;
        CustomUrlCopy.errorMessage = 'Error checking username.';
        CustomUrlCopy.value = '';
        onCustomUrlSelect(CustomUrlCopy);
      }
    } catch (error) {
      console.error(languageSetting === "ENGLISH" ? 'Error checking username:' : 'Error al verificar el nombre de usuario:', error);
      const CustomUrlCopy = JSON.parse(JSON.stringify(selectedCustomUrl));
      CustomUrlCopy.error = true;
      CustomUrlCopy.errorMessage = languageSetting === "ENGLISH" ? 'Error checking username.' : 'Error al verificar el nombre de usuario.';
      CustomUrlCopy.value = '';
      onCustomUrlSelect(CustomUrlCopy);
    }
  };

  const handleCopyClick = () => {
    const url = `https://eztiptap/${temporaryUsername}/me`;
    navigator.clipboard.writeText(url).then(() => {
      alert(languageSetting === "ENGLISH" ? "URL copied to clipboard!" : "URL copiada al portapapeles!");
    });
  };

  if (inline) {
    return (
      <div className="inline-custom-url">
        {!isEditing ? (
          <>
            <div className="inline-display">
              <span className="custom-id-value">{selectedCustomUrl.value || 'No custom ID'}</span>
            </div>
            <div className="button-row">
              <button className="edit-btn" onClick={handleYesClick}>
                Edit
              </button>
              <button className="save-custom-id-btn" onClick={onSave}>
                Save
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="inline-display">
              <input
                type="text"
                className="input-field inline"
                placeholder="Enter custom ID..."
                value={temporaryUsername || ''}
                onChange={handleInputChange}
                onBlur={handleBlur}
                maxLength={20}
              />
            </div>
            <div className="button-row">
              <button className="edit-btn" onClick={handleYesClick}>
                {languageSetting === "ENGLISH" ? "Edit" : "Editar"}
              </button>
              <button className="cancel-btn" onClick={handleNoClick}>
                {languageSetting === "ENGLISH" ? "Cancel" : "Cancelar"}
              </button>
            </div>
          </>
        )}
        {selectedCustomUrl.error && (
          <div className="error-text inline">{selectedCustomUrl.errorMessage}</div>
        )}
      </div>
    );
  }

  return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
        <div className="onboarding-instructions">
          <div className="main-instructions">{languageSetting === "ENGLISH" ? "Would you like a custom URL?" : "¿Te gustaría una URL personalizada?"}</div>
        </div>
        <div className="button-row">
          <button className="option-button" onClick={handleYesClick}>{languageSetting === "ENGLISH" ? "Yes" : "Si"}</button>
          <button className="option-button" onClick={handleNoClick}>No</button>
        </div>
        {selectedCustomUrl.showInput && (
          <div className="input-container">
            <br />
            <p className="centered-text">{languageSetting === "ENGLISH" ? "Provide a username" : "Proporciona un nombre de usuario"}</p>
            <input
              type="text"
              className="input-field"
              placeholder={languageSetting === "ENGLISH" ? "Enter custom username..." : "Ingresa un nombre de usuario personalizado..."}
              value={temporaryUsername || ''}
              onChange={handleInputChange}
              onBlur={handleBlur}
              maxLength={10}
            />
            {selectedCustomUrl.error && (
              <p className="error-text">{selectedCustomUrl.errorMessage}</p>
            )}
          </div>
        )}
        {temporaryUsername && (
          <div className="custom-url-container">
            <p className="custom-url-text">
              {languageSetting === "ENGLISH" ? "Your custom URL:" : "Tu URL personalizada:"} <span className="url-highlight">https://eztiptap/{temporaryUsername}/</span>
            </p>
            <div className="copy-url-button" onClick={handleCopyClick}>
              {languageSetting === "ENGLISH" ? "Copy URL" : "Copiar URL"}
            </div>
          </div>
        )}
      </div>
  );
};

export default CreateCustomUrl;